export const countryDialCodes = {
  "Zimbabwe": "+263",
  "Kiribati": "+686",
  "Ghana": "+233",
  "North Korea": "+850",
  "Spain": "+34",
  "Jordan": "+962",
  "San Marino": "+378",
  "Ivory Coast": "+225",
  "Brazil": "+55",
  "Colombia": "+57",
  "Dominica": "+1767",
  "Djibouti": "+253",
  "Slovenia": "+386",
  "Anguilla": "+1264",
  "North Macedonia": "+389",
  "Solomon Islands": "+677",
  "Chad": "+235",
  "Burundi": "+257",
  "Italy": "+39",
  "Ethiopia": "+251",
  "Vietnam": "+84",
  "Togo": "+228",
  "Martinique": "+596",
  "Poland": "+48",
  "Portugal": "+351",
  "Christmas Island": "+61",
  "Israel": "+972",
  "Argentina": "+54",
  "Afghanistan": "+93",
  "Papua New Guinea": "+675",
  "New Zealand": "+64",
  "El Salvador": "+503",
  "Czechia": "+420",
  "Cameroon": "+237",
  "Yemen": "+967",
  "Panama": "+507",
  "Timor-Leste": "+670",
  "Cuba": "+53",
  "Russia": "+73",
  "Antigua and Barbuda": "+1268",
  "Saint Barthélemy": "+590",
  "Bolivia": "+591",
  "Australia": "+61",
  "United States Minor Outlying Islands": "+268",
  "Fiji": "+679",
  "Myanmar": "+95",
  "São Tomé and Príncipe": "+239",
  "Madagascar": "+261",
  "Tuvalu": "+688",
  "Guernsey": "+44",
  "Cocos (Keeling) Islands": "+61",
  "Hungary": "+36",
  "Egypt": "+20",
  "Kyrgyzstan": "+996",
  "Indonesia": "+62",
  "Tunisia": "+216",
  "American Samoa": "+1684",
  "Oman": "+968",
  "French Polynesia": "+689",
  "United States": "+1201",
  "Falkland Islands": "+500",
  "Saint Martin": "+590",
  "Suriname": "+597",
  "Azerbaijan": "+994",
  "Netherlands": "+31",
  "Palestine": "+970",
  "Slovakia": "+421",
  "Uganda": "+256",
  "Cayman Islands": "+1345",
  "Saint Lucia": "+1758",
  "Libya": "+218",
  "Northern Mariana Islands": "+1670",
  "Armenia": "+374",
  "Comoros": "+269",
  "Guyana": "+592",
  "United Arab Emirates": "+971",
  "Turkey": "+90",
  "Samoa": "+685",
  "Germany": "+49",
  "Gambia": "+220",
  "Mongolia": "+976",
  "Serbia": "+381",
  "China": "+86",
  "Montenegro": "+382",
  "Guam": "+1671",
  "Cambodia": "+855",
  "Liechtenstein": "+423",
  "Senegal": "+221",
  "United Kingdom": "+44",
  "Caribbean Netherlands": "+599",
  "French Guiana": "+594",
  "Burkina Faso": "+226",
  "Qatar": "+974",
  "Ukraine": "+380",
  "Mexico": "+52",
  "Isle of Man": "+44",
  "South Georgia": "+500",
  "Western Sahara": "+2125288",
  "Turks and Caicos Islands": "+1649",
  "Albania": "+355",
  "Cyprus": "+357",
  "Guatemala": "+502",
  "Nauru": "+674",
  "Saint Helena, Ascension and Tristan da Cunha": "+290",
  "Latvia": "+371",
  "Cook Islands": "+682",
  "Malta": "+356",
  "Pitcairn Islands": "+64",
  "South Korea": "+82",
  "New Caledonia": "+687",
  "Mozambique": "+258",
  "Luxembourg": "+352",
  "Ireland": "+353",
  "Nigeria": "+234",
  "Bahamas": "+1242",
  "Marshall Islands": "+692",
  "Greece": "+30",
  "Maldives": "+960",
  "Niue": "+683",
  "Syria": "+963",
  "Ecuador": "+593",
  "Turkmenistan": "+993",
  "Wallis and Futuna": "+681",
  "Brunei": "+673",
  "Uzbekistan": "+998",
  "Bahrain": "+973",
  "British Virgin Islands": "+1284",
  "Moldova": "+373",
  "Mauritius": "+230",
  "Tonga": "+676",
  "Seychelles": "+248",
  "Angola": "+244",
  "Estonia": "+372",
  "Bermuda": "+1441",
  "Philippines": "+63",
  "Vatican City": "+3906698",
  "Venezuela": "+58",
  "Barbados": "+1246",
  "India": "+91",
  "Mali": "+223",
  "Norfolk Island": "+672",
  "Belarus": "+375",
  "Saint Kitts and Nevis": "+1869",
  "Guadeloupe": "+590",
  "Lithuania": "+370",
  "Montserrat": "+1664",
  "Niger": "+227",
  "Equatorial Guinea": "+240",
  "Iraq": "+964",
  "Mauritania": "+222",
  "Taiwan": "+886",
  "Georgia": "+995",
  "Puerto Rico": "+1787",
  "Paraguay": "+595",
  "Sierra Leone": "+232",
  "Botswana": "+267",
  "Mayotte": "+262",
  "Finland": "+358",
  "Jersey": "+44",
  "Faroe Islands": "+298",
  "Sweden": "+46",
  "Sri Lanka": "+94",
  "Thailand": "+66",
  "Greenland": "+299",
  "Bulgaria": "+359",
  "Kenya": "+254",
  "Hong Kong": "+852",
  "Romania": "+40",
  "Malawi": "+265",
  "Republic of the Congo": "+242",
  "Honduras": "+504",
  "Aruba": "+297",
  "Monaco": "+377",
  "Bouvet Island": "+47",
  "Zambia": "+260",
  "Andorra": "+376",
  "Liberia": "+231",
  "Tanzania": "+255",
  "Saint Pierre and Miquelon": "+508",
  "Iran": "+98",
  "Iceland": "+354",
  "Guinea": "+224",
  "Svalbard and Jan Mayen": "+4779",
  "Kuwait": "+965",
  "Morocco": "+212",
  "Namibia": "+264",
  "Tajikistan": "+992",
  "Vanuatu": "+678",
  "Jamaica": "+1876",
  "Palau": "+680",
  "Uruguay": "+598",
  "Bhutan": "+975",
  "DR Congo": "+243",
  "Kazakhstan": "+76",
  "Eritrea": "+291",
  "Gibraltar": "+350",
  "Gabon": "+241",
  "Peru": "+51",
  "Denmark": "+45",
  "Croatia": "+385",
  "Curaçao": "+599",
  "British Indian Ocean Territory": "+246",
  "Norway": "+47",
  "Lesotho": "+266",
  "Austria": "+43",
  "Switzerland": "+41",
  "Belize": "+501",
  "Belgium": "+32",
  "Nicaragua": "+505",
  "United States Virgin Islands": "+1340",
  "Singapore": "+65",
  "Dominican Republic": "+1809",
  "Kosovo": "+383",
  "Laos": "+856",
  "Chile": "+56",
  "Costa Rica": "+506",
  "Rwanda": "+250",
  "Trinidad and Tobago": "+1868",
  "Malaysia": "+60",
  "South Africa": "+27",
  "Saudi Arabia": "+966",
  "Haiti": "+509",
  "French Southern and Antarctic Lands": "+262",
  "Tokelau": "+690",
  "Somalia": "+252",
  "Japan": "+81",
  "Macau": "+853",
  "Sudan": "+249",
  "Algeria": "+213",
  "Eswatini": "+268",
  "France": "+33",
  "Sint Maarten": "+1721",
  "Bangladesh": "+880",
  "Central African Republic": "+236",
  "Canada": "+1",
  "Réunion": "+262",
  "Saint Vincent and the Grenadines": "+1784",
  "Micronesia": "+691",
  "Cape Verde": "+238",
  "Grenada": "+1473",
  "Pakistan": "+92",
  "Nepal": "+977",
  "Bosnia and Herzegovina": "+387",
  "South Sudan": "+211",
  "Guinea-Bissau": "+245",
  "Benin": "+229",
  "Lebanon": "+961",
  "Åland Islands": "+35818"
};